/** @jsxImportSource @emotion/react */

import styled from "@emotion/styled";
import { useMutation } from "react-query";
import { Screen, TextField } from "../components";
import { buttonStyle } from "../styles";
import * as colors from "../styles/colors";
import { small } from "../styles/media-queries";
import * as record from "../utils/record";

function CreateRecord() {
  const {
    isLoading,
    mutate: mutateCreateRecord,
    error,
  } = useMutation(record.createRecord);

  function handleSubmit(evt) {
    evt.preventDefault();
    const formData = new FormData(evt.target);
    const name = formData.get("name");
    const age = formData.get("age");
    const gender = formData.get("gender");
    const bloodGroup = formData.get("bloodGroup");
    const address = formData.get("address");
    const illnessDetails = formData.get("illnessDetails");
    const medicalRecords = formData.get("medicalRecords");

    mutateCreateRecord({
      name,
      age,
      gender,
      bloodGroup,
      address,
      illnessDetails,
      medicalRecords,
    });
  }
  return (
    <Screen>
      <div
        css={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          maxWidth: "1200px",
          width: "90%",
          margin: "auto",
        }}
      >
        <h1>Create New Record</h1>
        <form
          onSubmit={handleSubmit}
          css={{
            marginTop: "1em",
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: "1em",
            "& > div": {
              flex: "1 0 calc(50% - 1em)",

              [small]: {
                flexBasis: "100%",
              },
            },
          }}
        >
          <StyledTextField id="name" label="Name" />
          <StyledTextField type="number" id="age" label="Age" />
          <div>
            <div>Gender</div>
            <RadioWrap>
              <RadioInput
                type="radio"
                name="gender"
                id="gender-male"
                value="Male"
                required
              />
              <label htmlFor="gender-male">Male</label>
            </RadioWrap>
            <RadioWrap>
              <RadioInput
                type="radio"
                name="gender"
                id="gender-female"
                value="Female"
              />
              <label htmlFor="gender-female">Female</label>
            </RadioWrap>
            <RadioWrap>
              <RadioInput
                type="radio"
                name="gender"
                id="gender-other"
                value="Other"
              />
              <label htmlFor="gender-other">Other</label>
            </RadioWrap>
          </div>
          <StyledTextField id="bloodGroup" label="Blood Group" />
          <StyledTextField id="address" label="Address" />
          <StyledTextField id="illnessDetails" label="Illness Details" />
          <StyledTextField id="medicalRecords" label="Medical Records" />
          <div />
          <div css={{ display: "flex", justifyContent: "center" }}>
            <button
              css={{
                ...buttonStyle,
                color: colors.white,
                margin: "1em auto",
                fontWeight: 900,
                fontSize: "1.2em",
              }}
              disabled={isLoading}
            >
              {isLoading ? "Loading..." : "Submit"}
            </button>
          </div>
        </form>
        {error ? (
          <div css={{ textAlign: "center" }}>
            <p>Something went wrong!</p>
            <p css={{ marginTop: "1em" }}>{error.message}</p>
          </div>
        ) : null}
      </div>
    </Screen>
  );
}

const StyledTextField = styled(TextField)({
  fontSize: "1em",
});

const RadioWrap = styled.div({
  display: "inline-block",
  marginRight: "1em",
});

const RadioInput = styled.input({
  margin: "1em",
});

export default CreateRecord;
